import BaseComponent from 'foundation/base-component';
import {
    hasValue,
    isNullOrUndefined,
} from '../../../general/js/general-helpers';
import { initialiseEventCentreInstance } from '../../imga-iframe/js/imga-iframe-helpers';

export default class TabsComponent extends BaseComponent {
    constructor(...args) {
        super(...args);
        this.activeNavLinkNode = null;
        this.currentContentNode = null;

        this.links = this.refs.links;
        this.content = this.refs.content;
        this.state = {
            shotViewElement: null,
        };

        this.init();
    }

    init() {
        Object.keys(this.links).forEach((key) => {
            const link = this.links[key];
            this.addListener(link, 'click', this.onLinkClick.bind(this, link));

            if (link.classList.contains('is-active')) {
                if (!this.activeNavLinkNode) {
                    this.activeNavLinkNode = link;

                    const contentNode = this.content.find((tab) =>
                        link.hash.includes(tab.id));
                    if (contentNode) {
                        contentNode.classList.add('is-active');
                        this.currentContentNode = contentNode;
                    }
                } else {
                    // remove dublicate state if found
                    link.classList.remove('is-active');
                }
            }
        });
    }

    onLinkClick(link, e) {
        e.preventDefault();

        if (this.activeNavLinkNode) {
            this.activeNavLinkNode.classList.remove('is-active');
        }

        this.activeNavLinkNode = e.target;
        this.activeNavLinkNode.classList.add('is-active');
        const contentNode = this.content.find((tab) =>
            link.hash.includes(tab.id));
        this.showContent(contentNode);

        if (contentNode.id === 'widget-course-map') {
            this.loadShotView();
        }
    }

    loadShotView() {
        const shotViewCreator = window.frontRowSeat;
        const { eventCentreParameters } = this.options;

        const shotViewHolder = hasValue(eventCentreParameters.targetElement) ?
            document.getElementById(eventCentreParameters.targetElement) :
            null;

        if (
            !isNullOrUndefined(shotViewHolder) &&
            !isNullOrUndefined(shotViewCreator)
        ) {
            this.state.shotViewElement = initialiseEventCentreInstance(
                shotViewCreator,
                shotViewHolder
            );
        }
    }

    showContent(contentNode) {
        if (this.currentContentNode) {
            if (this.currentContentNode === contentNode) {
                return;
            }

            this.currentContentNode.classList.remove('is-active');
        }

        contentNode.classList.add('is-active');
        this.currentContentNode = contentNode;
    }
}
